/**
 * Enum for workflow options.
 * @readonly
 * @enum {string}
 *
 * * Note: Opening forms should have the same IDs as the forms themselves.
 */
export const WORKFLOW_OPTIONS = {
    // Warning modal open
    OPEN_SAFEGUARDING_DIALOG: 'openSafeguardingDialog',
    OPEN_CAUSE_FOR_CONCERN_DIALOG: 'openCauseForConcernDialog',
    OPEN_CFS_DIALOG: 'openCFSDialog',
    OPEN_MENTAL_HEALTH_DIALOG: 'openMentalHealthDialog',
    OPEN_EMPTY_DIAGNOSIS_MODAL: 'openEmptyDiagnosisModal',

    // Forms open
    NEURO_OBSERVATION: 'neuroObs',
    MEWS_OBSERVATION: 'mewsObs',
    SAFETY_CHECKLIST: 'safetyChecklist',
    SEPSIS_PATHWAY: 'sepsisPathway',
    CLINICAL_FRAILTY_SCORE: 'clinicalFrailtyScore',
    SAFEGUARDING: 'paedSafeguarding',
    SEPSIS: 'sepsisTool',
    CLINICAL_CONCLUSION: 'clinicalConclusion',
    VERIFICATION_OF_DEATH: 'vod',
    STREAMING_AND_REDIRECTION: 'streamingAndRedirection',

    // Other actions
    SEPSIS_AFTER_TRIAGE: 'sepsisAfterTriage',
};
